//GET /images 요청시 실어 보내는 query param 중
//prop.num key에 대한 value

//스탠다드 검색 prop.4(샷 구분) / UI 상으로 '프레임'이라고 명시한다
export enum StandardShotChildOptionValueEnum {
  '클로즈업' = 'CLOSE_UP',
  '미디엄샷' = 'MEDIUM_SHOT',
  '풀샷' = 'FULL_SHOT',
  '롱샷' = 'LONG_SHOT'
}

//19금 검색 prop.4(샷 구분) / UI 상으로 '프레임'이라고 명시한다
export enum AdultsOnlyShotChildOptionValueEnum {
  '풀샷' = 'FULL_SHOT',
  '미디엄샷' = 'MEDIUM_SHOT',
  '클로즈업' = 'CLOSE_UP'
}

//스탠다드 검색 prop.6(연령대)
export enum AgeRangeChildOptionValueEnum {
  '유아' = 'INFANT',
  '청소년' = 'ADOLESCENT',
  '청년' = 'YOUTH',
  '중장년' = 'MIDDLE_AGED',
  '노인' = 'SENIOR'
}

//스탠다드 검색 prop.9(중심동작부위)
export enum MainMotionPartChildOptionValueEnum {
  '손' = 'HAND',
  '팔' = 'ARM',
  '다리' = 'LEG',
  '발' = 'FOOT',
  '머리' = 'HEAD',
  '전신' = 'FULL_BODY',
  '상체' = 'UPPER_BODY',
  '하체' = 'LOWER_BODY'
}

//스탠다드 검색 prop.10(표정)
export enum StandardFacialExpressionChildOptionValueEnum {
  '없음' = 'NONE',

  // 긍정 카테고리
  '만족' = 'SATISFIED',
  '미소' = 'SMILING',
  '새침' = 'COY',
  '기쁨' = 'JOYFUL',
  '폭소' = 'LAUGHING',
  '수줍음' = 'SHY',

  // 중립 카테고리
  '무표정' = 'NEUTRAL',
  '놀람' = 'SURPRISED',
  '고민' = 'PENSIVE',
  '진지' = 'SERIOUS',

  // 부정 카테고리
  '혐오' = 'DISGUSTED',
  '분노' = 'ANGRY',
  '당황' = 'EMBARRASSED',
  '공포' = 'FEARFUL',
  '슬픔' = 'SAD',
  '경계' = 'CAUTIOUS',
  '좌절' = 'FRUSTRATED',
  '뻔뻔' = 'SHAMELESS',
  '수치' = 'ASHAMED',
  '의심' = 'SUSPICIOUS',
  '불안' = 'ANXIOUS',
  '절규' = 'SCREAMING'
}

//스탠다드 검색 prop.28(동작구분)
export enum PostureCategoryChildOptionValueEnum {
  '없음' = 'NONE',
  '서있음' = 'STANDING',
  '앉음' = 'SITTING',
  '누움' = 'LYING',
  '엎드림' = 'PRONE'
}

export enum FemaleBodyChildOptionValueEnum {
  '슬랜더' = 'SLENDER',
  '글래머' = 'GLAMOUR',
  '슈퍼글래머' = 'SUPER_GLAMOUR',
  '통통' = 'CHUBBY'
}

export enum SexualBodyPartChildOptionValueEnum {
  '가슴' = 'BREASTS',
  '엉덩이' = 'BUTTOCKS',
  '여자 성기' = 'FEMALE_GENITALIA',
  '남자 성기' = 'MALE_GENITALIA',
  '입' = 'MOUTH',
  '얼굴' = 'FACE'
}

export enum HorizontalAngleChildOptionValueEnum {
  '정면' = 'FRONT_VIEW',
  '정측면' = 'FRONT_SIDE_VIEW',
  '측면' = 'SIDE_VIEW',
  '후측면' = 'REAR_SIDE_VIEW',
  '후면' = 'REAR_VIEW'
}

export enum VerticalAngleChildOptionValueEnum {
  '로우앵글' = 'LOW_ANGLE',
  '하이앵글' = 'HIGH_ANGLE',
  '항공샷' = 'AERIAL_SHOT',
  '평시각' = 'EYE_LEVEL'
}

export enum SexualPositionChildOptionValueEnum {
  '정상위' = 'NORMAL_POSITION',
  '기승위' = 'RISING_POSITION',
  '후배위' = 'BACK_POSITION',
  '측위' = 'SIDE_POSITION',
  '굴곡위' = 'CURVED_POSITION',
  '교차위' = 'CROSS_POSITION',
  '좌위' = 'SITTING_POSITION',
  '입위' = 'STANDING_POSITION',
  '펠라치오' = 'FELLATIO',
  '커닐링구스' = 'CUNNILINGUS',
  '핑거링' = 'FINGERING',
  '69체위' = 'POSITION_69',
  '파이즈리' = 'PAIZURI',
  '남성자위' = 'MALE_MASTURBATION',
  '여성자위' = 'FEMALE_MASTURBATION',
  '탈의/샤워' = 'UNDRESSING_SHOWER',
  '쓰리썸/난교' = 'THREESOME_ORGY',
  'BDSM' = 'BDSM',
  '애무' = 'FOREPLAY',
  '발기' = 'ERECTION',
  '키스' = 'KISS',
  '여체 강조' = 'FEMALE_BODY_EMPHASIS',
  '모든 체위' = 'ALL'
}

export enum ActionGenreChildOptionValueEnum {
  '펀치' = 'PUNCH',
  '킥' = 'KICK',
  '유술' = 'GRAPPLING',
  '피격' = 'HIT',
  '냉병기' = 'COLD_WEAPON',
  '화기' = 'FIREARM',
  '기타' = 'ETC'
}

export enum BodyPartChildOptionValueEnum {
  '손' = 'HAND',
  '발' = 'FOOT',
  '팔' = 'ARM',
  '다리' = 'LEG',
  '입' = 'MOUTH',
  '눈' = 'EYE'
}

//스페셜 단추 표정 검색 prop.10(표정)
export enum FacialExpressionChildOptionValueEnum {
  '혐오' = 'DISGUST',
  '분노' = 'ANGRY',
  '당황' = 'EMBARRASSED'
}

export enum EtcChildOptionValueEnum {
  '오브젝트' = 'OBJECT',
  '인외존재' = 'NON_HUMAN'
}
